module.exports = __webpack_public_path__ + "img/Taylors_Bell_Foundry_0177.4245a2d9.jpg";